export default "__VITE_ASSET__CrVc0o5U__"